// Generated by ReScript, PLEASE EDIT WITH CARE


var formSubmitGaEventPrefix = "Get Trip Estimate Click - ";

function submitButtonGaEvent(category, requirement) {
  if (requirement !== 4) {
    if (requirement !== 0) {
      return formSubmitGaEventPrefix + (
              category === "Home" ? category + " Trucks" : "trucks"
            );
    } else {
      return formSubmitGaEventPrefix + (
              category === "Home" ? category + " 2W" : "2 wheeler"
            );
    }
  } else {
    return formSubmitGaEventPrefix + (
            category === "Home" ? category + " Trucks" : "trucks"
          );
  }
}

var gaEventTrucks = "trucks";

var gaFareEstimateSuccessfulTrucks = "Get Trip Estimate Successful - Trucks";

var gaFareEstimateSuccessful2w = "Get Trip Estimate Successful - 2W";

var gaDownloadPorterClick = "App Download/<Click>";

var spotSource = "spot_lead_flow";

var gaModalCitySelection = "City Selection Dropdown Desktop/<Click>";

var gaModalCitySelectionMobile = "City Selection Dropdown Mobile/<Click>";

var gaGetEstimateSticky = "Get Estimate Sticky Button Click";

var gaServiceCardRedirect = "Other Services - ";

var gaExploreFleet = "Explore/See our Fleet Button Click";

var gaEvent2w = "2w";

var gaCitySelectorAction = "City Selection Dropdown/<Click>";

var gaGetEstimateAction = "Get Estimate Button Click/<Click>";

var gaButtonStickyTopCloseAction = "Sticky Download - Top Close";

var gaButtonStickyTopDownloadAction = "Sticky Download - Top";

var gaCategoryCardAction = " Category Card Click";

var gaServiceCardAction = "Service Card Click - ";

var gaOfferCardAction = "Offer Card Click";

var gaEstimateCategoryCardAction = "Estimate Card Click - ";

var gaEstimateVerticalSwitchAction = "Change Category Switch /<Click>";

var gaEstimateVerticalSwitchCategoryAction = "Change Category Switch from ";

var gaHamburgerMobileAction = "Mobile Menu Migrated /<Click>";

var gaReadArticleAction = "News Article Redirect";

var gaHeaderLinkAction = "Header Link /Click<Redirect>";

var gaHeaderSpecificLinkAction = "Header Link Redirect";

var gaFooterSpecificLinkAction = "Footer Click - ";

var gaHeaderHamburgerAction = "Mobile Menu Overlay Close";

var gaHeaderHomeAction = "Header Logo /<Click>";

var gaPageLanding = "fe_home_land";

var gaGetEstimateActionV2 = "fe_home_getest_tap";

var fareEstimateResult = "Fare Estimate Result";

var gaEventExploreOtherServices = " Banner Click - Fare Estimate Page";

var gaDownloadLinkFare = "Download Section - Fare Estimate";

var gaDownloadLinkAndroid = "Download Section - Android";

var gaDownloadLinkIos = "Download Section - iOS";

var gaFareEstimateFormValidation = "Get Trip Estimate Validation Successful";

var gaLanguageChange = "fe_home_language_switch_click";

var gaFareEstimateSuccessfulBd = "Get Trip Estimate Successful Bangladesh";

var gaFareEstimateClickBd = "Get Trip Estimate Click Bangladesh";

var gaFooterPlaystore = "Google Play button clicked ";

var gaFooterAppstore = "App Store button clicked ";

var gaFareEstimateClickUae = "Get Trip Estimate Click UAE";

var gaFareEstimateSuccessfulUae = "Get Trip Estimate Successful UAE";

var gaFareEstimateSuccessfulV2Uae = "Fare Estimate Successful V2 UAE";

var gaFareEstimateError = "Get Trip Estimate Failure ";

var gaFareEstimateSuccessfulTurkey = "Get Trip Estimate Successful Turkiye";

var gaFareEstimateClickTurkey = "Get Trip Estimate Click Turkiye";

var gaFareEstimateSuccessful = "Get Trip Estimate Successful";

var gaFareEstimateClick = "Get Trip Estimate Click";

var gaTitleHome = "Home";

export {
  gaEventTrucks ,
  gaFareEstimateSuccessfulTrucks ,
  gaFareEstimateSuccessful2w ,
  gaDownloadPorterClick ,
  spotSource ,
  gaModalCitySelection ,
  gaModalCitySelectionMobile ,
  gaGetEstimateSticky ,
  gaServiceCardRedirect ,
  gaExploreFleet ,
  gaEvent2w ,
  gaCitySelectorAction ,
  gaGetEstimateAction ,
  gaButtonStickyTopCloseAction ,
  gaButtonStickyTopDownloadAction ,
  gaCategoryCardAction ,
  gaServiceCardAction ,
  gaOfferCardAction ,
  gaEstimateCategoryCardAction ,
  gaEstimateVerticalSwitchAction ,
  gaEstimateVerticalSwitchCategoryAction ,
  gaHamburgerMobileAction ,
  gaReadArticleAction ,
  gaHeaderLinkAction ,
  gaHeaderSpecificLinkAction ,
  gaFooterSpecificLinkAction ,
  gaHeaderHamburgerAction ,
  gaHeaderHomeAction ,
  gaPageLanding ,
  gaGetEstimateActionV2 ,
  formSubmitGaEventPrefix ,
  fareEstimateResult ,
  gaEventExploreOtherServices ,
  gaDownloadLinkFare ,
  gaDownloadLinkAndroid ,
  gaDownloadLinkIos ,
  gaFareEstimateFormValidation ,
  gaLanguageChange ,
  gaFareEstimateSuccessfulBd ,
  gaFareEstimateClickBd ,
  gaFooterPlaystore ,
  gaFooterAppstore ,
  gaFareEstimateClickUae ,
  gaFareEstimateSuccessfulUae ,
  gaFareEstimateSuccessfulV2Uae ,
  gaFareEstimateError ,
  gaFareEstimateSuccessfulTurkey ,
  gaFareEstimateClickTurkey ,
  gaFareEstimateSuccessful ,
  gaFareEstimateClick ,
  gaTitleHome ,
  submitButtonGaEvent ,
}
/* No side effect */
